import { IsNull } from "@/utils/utils";

export default class DataListParam {

  constructor(params) {

    if (params) {
      Object.assign(this, params);
    }

    if (IsNull(this.SearchCondition)) {
      this.SearchCondition = [];
    }

    if (IsNull(this.ReturnColumns)) {
      this.ReturnColumns = [];
    }

  }

  /// 列表code
  AppItemCode;
  //子表关联Code
  ChildListCode;
  ///流程id
  //InstanceId;
  /// 排序字段
  //SortName;
  ///排序类型
  //SortType;
  ///基础查询
  SearchKey;
  // 场景
  SelfSearchCondition;
  ///分页消息
  PagingInfo;
  /// 显示模式
  //ListMode;
  /// 高级搜索
  SearchCondition;

  // 要查哪些列
  ReturnColumns;

  // tab列表的参数
  RelTabParam;
}

/**
 * tab列表的参数
 */
export class RelTabParam {
  constructor(mainFormCode, mainDataId, listTab, formParams = null) {
    this.MainFormCode = mainFormCode;
    this.MainDataId = mainDataId;
    this.ListTab = listTab;
    if (formParams) {
      this.formParams = formParams;
    }
  }

  /**主表单formCode */
  MainFormCode;

  /**主表单dataId */
  MainDataId;

  /**表单tab列表参数 */
  ListTab;

  /**页签表单参数 */
  formParams;
}